/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const GuestProfileFormSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={180} className={classes.shortSk} />
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRowAuto}>
          <Skeleton count={1} width={80} className={classes.longSkM} />
          <Skeleton count={1} width={60} className={classes.longSk} />
        </div>
      </div>
      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>
      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <div className={classes.secondRowAuto}>
            <Skeleton count={1} width={340} className={classes.longSkM} />
            <Skeleton count={1} width={180} className={classes.longSk} />
          </div>
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <div className={classes.secondRowAuto}>
            <Skeleton count={1} width={340} className={classes.longSkM} />
            <Skeleton count={1} width={180} className={classes.longSk} />
          </div>          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
        </div>
      </div>
      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>
      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
        </div>
      </div>

      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>

      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
        </div>
      </div>

      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>

      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={540} className={classes.longSk} />
          <Skeleton count={1} width={120} className={classes.shortSk} />
          <Skeleton count={1} width={340} className={classes.longSk} />
        </div>
      </div>

      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>

      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={280} className={classes.shortSk} />
        </div>
        <div className={classes.secondRow}>
          <Skeleton count={1} width={120} className={classes.shortSk} />
        </div>
      </div>

      <div className={classes.dividerContainer}>
        <hr className={classes.border} />
      </div>

      <div className={classes.firstPart}>
        <div className={classes.firstRow}>
          <Skeleton count={1} width={180} className={classes.shortSk} />
        </div>
        <div className={classes.secondRowAuto}>
          <Skeleton count={1} width={80} className={classes.longSkM} />
          <Skeleton count={1} width={60} className={classes.longSk} />
        </div>
      </div>
    </div>
  );
};

export default GuestProfileFormSkeleton;